import { selectUser } from '@/redux/auth/authSlice';
import { useEffect, useState } from 'react';
import { gePin } from '../../api/queries/getData';
import { selectPin, setPin } from '../../redux/config/configSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { store } from '../../redux/store';

const usePinSetter = () => {
  const user = useAppSelector(selectUser);
  const dispatch = useAppDispatch();
  const fetchPin = async () => {
    const storedPined = store.getState().config.pin;
    return gePin().then((res) => {
      if (res != storedPined) dispatch(setPin(res));
    });
  };
  useEffect(() => {
    if (user) fetchPin();
  }, [user]);

  return { refetch: fetchPin };
};

const usePinChecker = () => {
  const [allow, setAllow] = useState(true);
  const pin = useAppSelector(selectPin);

  const handleVisibilityChange = () => {
    setAllow(false);
  };

  useEffect(() => {
    if (!pin || !store.getState().auth.user) return setAllow(true);
    setAllow(false);

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [pin]);

  return { pin, allow, setAllow };
};

export { usePinChecker, usePinSetter };
